import { render } from "./LogsMoodleUndbClassroom.vue?vue&type=template&id=faf2d684"
import script from "./LogsMoodleUndbClassroom.vue?vue&type=script&lang=js"
export * from "./LogsMoodleUndbClassroom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__